import { MutableRefObject } from 'react';
import { GridRowData } from '@material-ui/x-grid';
import { useSelector } from 'react-redux';
import DatagridHoverTooltip from 'src/components/Datagrid/DatagridHoverTooltip';
import {
  PAYMENT_METHOD_TYPES, PAYMENT_TYPE, PaymentMethodModel,
} from 'src/models/PaymentModel';
import { getPaymentMethodAction } from 'src/redux/actions/paymentActions';
import { Store, useAppDispatch } from 'src/redux/Store';

const PAYMENT_TYPE_FIELD = 'payments.payment_type';
const PAYMENT_INFO_ID_FIELD = 'payments.payment_info_id';

interface Props {
  containerRef: MutableRefObject<HTMLDivElement | null>;
  rows: GridRowData[];
  reloadKey?: unknown;
}

const getPaymentMethodLabel = (paymentMethod: PaymentMethodModel) => {
  if (paymentMethod.kind === 'card') {
    return `${paymentMethod.maskedCardNumber} · ${paymentMethod.expirationData}`;
  }

  return [
    paymentMethod.bankName,
    paymentMethod.bankHolderName,
    paymentMethod.account,
  ].filter(Boolean).join(' · ');
};

const DatagridPaymentMethodTooltip = (props: Props) => {
  const { containerRef, rows, reloadKey } = props;
  const dispatch = useAppDispatch();
  const organisationId = useSelector((state: Store) => state.currentOrganisation.id);

  const isRowSupported = (row: GridRowData): boolean => {
    const paymentTypeHint = row[PAYMENT_TYPE_FIELD] as PAYMENT_TYPE | undefined;
    const paymentInfoIdHint = row[PAYMENT_INFO_ID_FIELD] as number | null | undefined;

    if (paymentTypeHint && !PAYMENT_METHOD_TYPES.includes(paymentTypeHint)) {
      return false;
    }

    return paymentInfoIdHint !== null;
  };

  const loadContent = async (row: GridRowData) => {
    const paymentId = Number(row.id);
    const paymentTypeHint = row[PAYMENT_TYPE_FIELD] as PAYMENT_TYPE | undefined;
    const paymentInfoIdHint = row[PAYMENT_INFO_ID_FIELD] as number | null | undefined;

    const paymentMethod = await dispatch(
      getPaymentMethodAction(paymentId, paymentTypeHint, paymentInfoIdHint),
    ) as PaymentMethodModel | null;

    return paymentMethod ? getPaymentMethodLabel(paymentMethod) : null;
  };

  return (
    <DatagridHoverTooltip
      containerRef={containerRef}
      rows={rows}
      reloadKey={reloadKey}
      cacheKey={organisationId}
      isRowSupported={isRowSupported}
      loadContent={loadContent} />
  );
};

export default DatagridPaymentMethodTooltip;
